import { render, staticRenderFns } from "./RoomCreatedAtChip.vue?vue&type=template&id=da2ee964&lang=pug&"
import script from "./RoomCreatedAtChip.vue?vue&type=script&lang=ts&"
export * from "./RoomCreatedAtChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomCreatedAtChip.vue"
export default component.exports